/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const mentionableUserDataSchema = z.object({
	id: z.string(),
	name: z.string(),
	email: z.string(),
})

export type MentionableUserDataSchema = z.infer<typeof mentionableUserDataSchema>
